import { AppState } from '../types/store';

export const getSalesFetchParams = (state: AppState) =>
  state?.salesPage?.fetchParams || {};
